import { FunctionComponent, useCallback, useState } from "react";
import { getQuery } from "../../utils/query";
import ClickableDiv from "../shared/ClickableDiv";
import LoginForm from "./LoginForm";
import { LoginIcon } from "../shared/Icon";

interface IProps {
	reload(): void;
}

const LoginButton: FunctionComponent<IProps> = (props) => {
	const { reload } = props;

	const action = getQuery("action");
	const [isOpen, setIsOpen] = useState<boolean>(action === "resetPassword");

	const displayLoginForm = useCallback(() => { setIsOpen(true); }, []);
	const closeLogin = useCallback(() => setIsOpen(false), []);

	return <>
		<ClickableDiv id="signInButton" onClick={displayLoginForm}>
			<span><LoginIcon /><span className="loginLabel"> Login</span></span>
		</ClickableDiv>
		<LoginForm isOpen={isOpen} onClose={closeLogin} onLogin={reload} />
	</>;
}

export default LoginButton;